import {
    IPractitionerState,
    IUserState,
    PractitionerActionTypes,
    ADD_PRACTITIONER_LANGUAGE,
    ADD_PRACTITIONER_SPECIALIZATION,
    GET_PRACTITIONER_DATA_REQUEST,
    GET_PRACTITIONER_DATA_SUCCESS,
    GET_USER_DATA_REQUEST,
    GET_USER_DATA_SUCCESS,
    REMOVE_PRACTITIONER_LANGUAGE,
    REMOVE_PRACTITIONER_SPECIALIZATION,
    SET_PAYMENT_DETAILS_UPDATES,
    SET_PRACTITIONER_LANGUAGES,
    SET_PRACTITIONER_SPECIALIZATIONS,
    UserActionTypes,
} from './types';
import PractitionerSpecializationModel from '../models/PractitionerSpecializationModel';
import LanguageModel from '../models/LanguageModel';

export const userInitialState: IUserState = {
    user: undefined,
    error: null,
};

export const practitionerInitialState: IPractitionerState = {
    practitioner: undefined,
    error: null,
    settingsUpdated: false,
    languages: [],
    specializations: [],
};

export function practitionerReducer(
    state = practitionerInitialState,
    action: PractitionerActionTypes,
): IPractitionerState {
    switch (action.type) {
        case GET_PRACTITIONER_DATA_REQUEST:
            return {
                ...state,
                practitioner: undefined,
            };

        case GET_PRACTITIONER_DATA_SUCCESS:
            return {
                ...state,
                practitioner: action.payload,
            };

        case SET_PAYMENT_DETAILS_UPDATES:
            return {
                ...state,
                settingsUpdated: action.payload,
            };

        case SET_PRACTITIONER_LANGUAGES:
            return {
                ...state,
                languages: action.payload,
            };

        case ADD_PRACTITIONER_LANGUAGE:
            return {
                ...state,
                languages: [...state.languages, action.payload],
            };

        case REMOVE_PRACTITIONER_LANGUAGE:
            return {
                ...state,
                languages: state.languages.filter((l: LanguageModel) => l.id !== action.payload),
            };

        case SET_PRACTITIONER_SPECIALIZATIONS:
            return {
                ...state,
                specializations: action.payload,
            };

        case ADD_PRACTITIONER_SPECIALIZATION:
            return {
                ...state,
                specializations: [...state.specializations, action.payload],
            };

        case REMOVE_PRACTITIONER_SPECIALIZATION:
            return {
                ...state,
                specializations: state.specializations.filter(
                    (s: PractitionerSpecializationModel) => s.id !== action.payload,
                ),
            };

        default:
            return state;
    }
}

export function userReducer(state = userInitialState, action: UserActionTypes): IUserState {
    switch (action.type) {
        case GET_USER_DATA_REQUEST:
            return {
                ...state,
                user: undefined,
            };

        case GET_USER_DATA_SUCCESS:
            return {
                ...state,
                user: action.payload.user,
            };

        default:
            return state;
    }
}
